import React from 'react';

interface IProps {
  unlocked: boolean;
};

export const CornerIcon = (props: IProps) => {
  return (
    <div 
      className="z-10 bg-white border text-[1.5rem] font-bold text-center rounded-[4px] absolute px-1 bottom-0 right-0 -mb-2 -mr-2 cursor-pointer text-[#E2E2E2] border-[#E2E2E2] group-hover:bg-zeos-orange-dk group-hover:text-white group-hover:border-none"
    >
      {props.unlocked ? ">" : "+"}
    </div>
  );
};
